import { ReactElement, useContext, useEffect, useState } from 'react'
import { UserContext } from '../../../context/UserContext'
import UserAction from '../../../context/action/UserAction'
import { Collapse } from '@mui/material'
import DevelopusGrid from '../../../../../common/ui/grid/DevelopusGrid'
import LicenseCard from './LicenseCard'
import LicenseEdit from './LicenseEdit'
import { UpdateStudentUI } from '../../../model/UpdateStudentUI'

const LicensesView = (): ReactElement => {
  const context = useContext(UserContext)
  const action = new UserAction(context)

  const [student, setStudent] = useState<UpdateStudentUI | undefined>(
    action.getUpdateStudent()?.toUI(),
  )

  useEffect(() => {
    if (action.getUpdateStudent() === undefined) {
      const updateStudentUI = action.updateStudentFromCurrent()
      setStudent(updateStudentUI)
    }
  }, [])

  useEffect(() => {
    action.setUpdateStudent(student)
  }, [student])

  const licenseCardsUI =
    student !== undefined
      ? student.updateLicenses.licenses.map((updateLicense, idx) => {
          return (
            <LicenseCard
              key={idx}
              student={student}
              licenseUI={updateLicense}
            />
          )
        })
      : []

  return (
    <>
      <Collapse in={!action.isLicenseSelected()} timeout="auto" mountOnEnter>
        <DevelopusGrid elements={licenseCardsUI} />
      </Collapse>

      <Collapse in={action.isLicenseSelected()} timeout="auto" mountOnEnter>
        <LicenseEdit />
      </Collapse>
    </>
  )
}

export default LicensesView
